// This file is auto-generated by @hey-api/openapi-ts
import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  AddSubConfigurationData,
  AddSubConfigurationResponse,
  ChangeConfigurationData,
  ChangeConfigurationResponse,
  ChangeSubConfigurationData,
  ChangeSubConfigurationResponse,
  CloneConfigurationData,
  CloneConfigurationResponse,
  CommitConfigurationData,
  CommitConfigurationResponse,
  CreateConfigurationData,
  CreateConfigurationResponse,
  DeleteConfigurationData,
  DeleteConfigurationResponse,
  DeleteSubConfigurationData,
  DeleteSubConfigurationResponse,
  GetAssemblyData,
  GetAssemblyResponse,
  GetAssetData,
  GetAssetResponse,
  GetBomData,
  GetBomResponse,
  GetConfigurationData,
  GetConfigurationResponse,
  GetConfiguratorsData,
  GetConfiguratorsResponse,
  GetCurrenciesData,
  GetCurrenciesResponse,
  GetDrawingData,
  GetDrawingResponse,
  GetHealthResponse,
  GetInfoResponse,
  GetLayoutsData,
  GetLayoutsResponse,
  GetLocalesData,
  GetLocalesResponse,
  GetLogsData,
  GetLogsResponse,
  GetStatisticsResponse,
  GetStructuredTranslationsData,
  GetStructuredTranslationsResponse,
  GetSummaryData,
  GetSummaryResponse,
  GetTableData,
  GetTableResponse,
  GetThemesData,
  GetThemesResponse,
  GetUiLocalesData,
  GetUiLocalesResponse,
  GetUiTranslationsData,
  GetUiTranslationsResponse,
  GetUnitsData,
  GetUnitsResponse,
  InvokeUserDefinedFunctionData,
  InvokeUserDefinedFunctionResponse,
  InvokeUserDefinedGetterData,
  InvokeUserDefinedGetterResponse,
  KeepConfigurationAliveData,
  KeepConfigurationAliveResponse,
  LoadConfigurationData,
  LoadConfigurationResponse,
  ReloadResponse,
  ResetConfigurationAttributesData,
  ResetConfigurationAttributesResponse,
  ResetConfigurationData,
  ResetConfigurationResponse,
  RollbackConfigurationData,
  RollbackConfigurationResponse,
  SaveConfigurationData,
  SaveConfigurationResponse,
} from "./types.gen";

export class ConfigurationService {
  /**
   * Get API information of the configuration server.
   * @returns VersionInfo OK
   * @throws ApiError
   */
  public static getInfo(): CancelablePromise<GetInfoResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/info",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * Get load statistics of the configuration server.
   * @returns StatisticsInfo OK
   * @throws ApiError
   */
  public static getStatistics(): CancelablePromise<GetStatisticsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/statistics",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * Get the health status of the configuration server.
   * @returns HealthInfo OK
   * @throws ApiError
   */
  public static getHealth(): CancelablePromise<GetHealthResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/health",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * Get a list of supported locales for configuration.
   * @param data The data for the request.
   * @param data.releaseId The configurator ID.
   * @returns LocaleInfo OK
   * @throws ApiError
   */
  public static getLocales(
    data: GetLocalesData = {},
  ): CancelablePromise<GetLocalesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/locales",
      query: {
        releaseId: data.releaseId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get a list of supported UI locales for configuration.
   * @param data The data for the request.
   * @param data.releaseId The configurator ID.
   * @returns LocaleInfo OK
   * @throws ApiError
   */
  public static getUiLocales(
    data: GetUiLocalesData = {},
  ): CancelablePromise<GetUiLocalesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/uiLocales",
      query: {
        releaseId: data.releaseId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get all unit systems. This includes all units, unit groups and dimensions.
   * @param data The data for the request.
   * @param data.releaseId The configurator ID.
   * @returns ConfigurationUnits OK
   * @throws ApiError
   */
  public static getUnits(
    data: GetUnitsData = {},
  ): CancelablePromise<GetUnitsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/units",
      query: {
        releaseId: data.releaseId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get a list of supported currencies for pricing and costs.
   * @param data The data for the request.
   * @param data.releaseId The configurator ID.
   * @returns CurrencyInfo OK
   * @throws ApiError
   */
  public static getCurrencies(
    data: GetCurrenciesData = {},
  ): CancelablePromise<GetCurrenciesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/currencies",
      query: {
        releaseId: data.releaseId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get the theme definition.
   * @param data The data for the request.
   * @param data.releaseId The configurator ID.
   * @param data.themeId The theme ID.
   * @returns ThemeInfo OK
   * @throws ApiError
   */
  public static getThemes(
    data: GetThemesData = {},
  ): CancelablePromise<GetThemesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/themes",
      query: {
        releaseId: data.releaseId,
        themeId: data.themeId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get the layout definition to render a specific configuration object.
   * @param data The data for the request.
   * @param data.rootCfgObjectId The root configuration object ident (ID).
   * @param data.cfgObjectId The configuration object for which to receive the layout information.
   * @param data.releaseId The configurator ID.
   * @param data.layoutId The ID of the layout.
   * @returns LayoutInfo OK
   * @throws ApiError
   */
  public static getLayouts(
    data: GetLayoutsData,
  ): CancelablePromise<GetLayoutsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/layouts",
      query: {
        releaseId: data.releaseId,
        rootCfgObjectId: data.rootCfgObjectId,
        cfgObjectId: data.cfgObjectId,
        layoutId: data.layoutId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get UI translations for a specific UI context.
   * @param data The data for the request.
   * @param data.localeId The locale ID (e.g. en-US). If omitted or if the locale is not supported, the fallback translations will be returned.
   * @param data.contextId The UI context.
   * @param data.releaseId The configurator ID.
   * @returns string OK
   * @throws ApiError
   */
  public static getUiTranslations(
    data: GetUiTranslationsData,
  ): CancelablePromise<GetUiTranslationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/uiTranslations/{localeId}/{contextId}",
      path: {
        localeId: data.localeId,
        contextId: data.contextId,
      },
      query: {
        releaseId: data.releaseId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get structured translations for a specific configuration object or all configuration objects.
   * @param data The data for the request.
   * @param data.releaseId The configurator ID.
   * @param data.localeId The locale ID (e.g. en-US). If omitted or if the locale is not supported, the fallback translations will be returned.
   * @returns DictionaryEntry OK
   * @throws ApiError
   */
  public static getStructuredTranslations(
    data: GetStructuredTranslationsData = {},
  ): CancelablePromise<GetStructuredTranslationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/structuredTranslations",
      query: {
        releaseId: data.releaseId,
        localeId: data.localeId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get a static asset (e.g. image or PDF).
   * @param data The data for the request.
   * @param data.path The path of the asset.
   * @returns unknown OK
   * @throws ApiError
   */
  public static getAsset(
    data: GetAssetData,
  ): CancelablePromise<GetAssetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/assets/{path}",
      path: {
        path: data.path,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get a list of all independent configuration objects (all objects available for configuration by the user).
   * @param data The data for the request.
   * @param data.releaseId The configurator ID.
   * @param data.localeId The locale ID (RFC 4646, e.g. en-US).
   * @returns ConfigurationObjectInfo OK
   * @throws ApiError
   */
  public static getConfigurators(
    data: GetConfiguratorsData = {},
  ): CancelablePromise<GetConfiguratorsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/configurators",
      query: {
        releaseId: data.releaseId,
        localeId: data.localeId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Fetch a new version of the KB and reload the configurator, only new configurations will be affected.
   * @returns unknown OK
   * @throws ApiError
   */
  public static reload(): CancelablePromise<ReloadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/3pq-cs/v2/configuration/reload",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * Create a new configuration.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static createConfiguration(
    data: CreateConfigurationData,
  ): CancelablePromise<CreateConfigurationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/3pq-cs/v2/configuration/configurations",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Delete a configuration.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @returns unknown OK
   * @throws ApiError
   */
  public static deleteConfiguration(
    data: DeleteConfigurationData,
  ): CancelablePromise<DeleteConfigurationResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}",
      path: {
        id: data.id,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get (GET over POST) configuration objects of an existing configuration.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static getConfiguration(
    data: GetConfigurationData,
  ): CancelablePromise<GetConfigurationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Receive logs for the configuration (Web Socket or rest polling endpoint).
   * Logging must be enabled for the configuration and development mode must be enabled for the server.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @returns ConfigurationLogEvent OK
   * @throws ApiError
   */
  public static getLogs(data: GetLogsData): CancelablePromise<GetLogsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/logs",
      path: {
        id: data.id,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
        426: "Upgrade Required",
      },
    });
  }

  /**
   * Changes an existing configuration by selecting values and/or value quantifies.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static changeConfiguration(
    data: ChangeConfigurationData,
  ): CancelablePromise<ChangeConfigurationResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/change",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Create a new configuration as a clone of the current configuration.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static cloneConfiguration(
    data: CloneConfigurationData,
  ): CancelablePromise<CloneConfigurationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/clone",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Reset a list of attributes to their default value.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static resetConfigurationAttributes(
    data: ResetConfigurationAttributesData,
  ): CancelablePromise<ResetConfigurationAttributesResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/resetAttributes",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Reset the configuration or a sub-configuration.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static resetConfiguration(
    data: ResetConfigurationData,
  ): CancelablePromise<ResetConfigurationResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/reset",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Prevent the configuration from being garbage collected over time.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @returns unknown OK
   * @throws ApiError
   */
  public static keepConfigurationAlive(
    data: KeepConfigurationAliveData,
  ): CancelablePromise<KeepConfigurationAliveResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/keepAlive",
      path: {
        id: data.id,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Create a new sub-configuration.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static addSubConfiguration(
    data: AddSubConfigurationData,
  ): CancelablePromise<AddSubConfigurationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/subConfiguration",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Delete a sub-configuration.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static deleteSubConfiguration(
    data: DeleteSubConfigurationData,
  ): CancelablePromise<DeleteSubConfigurationResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/subConfiguration",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Copy or move a sub-configuration.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static changeSubConfiguration(
    data: ChangeSubConfigurationData,
  ): CancelablePromise<ChangeSubConfigurationResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/subConfiguration",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Commits the configuration changes.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static commitConfiguration(
    data: CommitConfigurationData,
  ): CancelablePromise<CommitConfigurationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/commit",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Rollback the configuration to the last commit.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static rollbackConfiguration(
    data: RollbackConfigurationData,
  ): CancelablePromise<RollbackConfigurationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/rollback",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Save the configuration as JSON.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.localeId The currency ID (ISO 4217, e.g. USD).
   * @param data.currencyId The path of the configuration object.
   * @param data.includeBom Include BOM
   * @param data.includeSummary Include summary
   * @returns ConfigurationSave OK
   * @throws ApiError
   */
  public static saveConfiguration(
    data: SaveConfigurationData,
  ): CancelablePromise<SaveConfigurationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/save",
      path: {
        id: data.id,
      },
      query: {
        localeId: data.localeId,
        currencyId: data.currencyId,
        includeBom: data.includeBom,
        includeSummary: data.includeSummary,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Restores a saved configuration from JSON.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static loadConfiguration(
    data: LoadConfigurationData,
  ): CancelablePromise<LoadConfigurationResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/load",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get a table of the given configuration object by path.
   * The getter must not have any side effects.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.requestBody
   * @returns ConfigurationTable OK
   * @throws ApiError
   */
  public static getTable(
    data: GetTableData,
  ): CancelablePromise<GetTableResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/table",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Invoke a user defined function in as specific configuration object.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.name The name of the user defined function.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static invokeUserDefinedFunction(
    data: InvokeUserDefinedFunctionData,
  ): CancelablePromise<InvokeUserDefinedFunctionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/userDefinedFunction/{name}",
      path: {
        id: data.id,
        name: data.name,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Invoke a user defined getter in as specific configuration object.
   * The getter must not have any side effects.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.name The name of the user defined getter.
   * @param data.requestBody
   * @returns Configuration OK
   * @throws ApiError
   */
  public static invokeUserDefinedGetter(
    data: InvokeUserDefinedGetterData,
  ): CancelablePromise<InvokeUserDefinedGetterResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/userDefinedGetter/{name}",
      path: {
        id: data.id,
        name: data.name,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get the configuration BOM.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.localeId The currency ID (ISO 4217, e.g. USD).
   * @param data.currencyId The path of the configuration object.
   * @returns ConfigurationBom OK
   * @throws ApiError
   */
  public static getBom(data: GetBomData): CancelablePromise<GetBomResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/bom",
      path: {
        id: data.id,
      },
      query: {
        localeId: data.localeId,
        currencyId: data.currencyId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get the configuration summary.
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.localeId The currency ID (ISO 4217, e.g. USD).
   * @param data.currencyId The path of the configuration object.
   * @returns ConfigurationSummary OK
   * @throws ApiError
   */
  public static getSummary(
    data: GetSummaryData,
  ): CancelablePromise<GetSummaryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/summary",
      path: {
        id: data.id,
      },
      query: {
        localeId: data.localeId,
        currencyId: data.currencyId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get the configuration assembly (2D or 3D).
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.localeId The currency ID (ISO 4217, e.g. USD).
   * @param data.currencyId The path of the configuration object.
   * @returns ConfigurationAssembly OK
   * @throws ApiError
   */
  public static getAssembly(
    data: GetAssemblyData,
  ): CancelablePromise<GetAssemblyResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/assembly",
      path: {
        id: data.id,
      },
      query: {
        localeId: data.localeId,
        currencyId: data.currencyId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }

  /**
   * Get the configuration drawing (2D or 3D).
   * @param data The data for the request.
   * @param data.id The configuration ID.
   * @param data.localeId The currency ID (ISO 4217, e.g. USD).
   * @param data.currencyId The path of the configuration object.
   * @returns ConfigurationDrawing OK
   * @throws ApiError
   */
  public static getDrawing(
    data: GetDrawingData,
  ): CancelablePromise<GetDrawingResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/3pq-cs/v2/configuration/configurations/{id}/drawing",
      path: {
        id: data.id,
      },
      query: {
        localeId: data.localeId,
        currencyId: data.currencyId,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        404: "Not Found",
      },
    });
  }
}
